<template lang="html">
  <div class="admin-email-wrapper">
    <div class="title">
      <span>Vesti</span>
      <input @keyup="getNews" v-model="search" type="text" placeholder="search" name="" value="">
    </div>
    <table>
      <thead>
        <tr>
          <td>Naslov vesti</td>
          <td style="width: 40px"></td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="news in newsList" :key="news.new_id">
          <td>
            {{news.new_title}}
          </td>
          <td>
            <div @click="openConfirmModal(news)" class="btn">
              obriši
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="action-wrapper">
      <div v-if="newsList.length > 0" class="pagination-wrapper">
        <paginate
          v-model="page"
          :page-count="pageCount"
          :prev-text="getPaginationImages('Left')"
          :next-text="getPaginationImages('Right')"
          :container-class="'pagination'"
          :page-class="'page'"
          :click-handler="changePage"
        >
        </paginate>
      </div>
      <div @click="openNewModal" class="btn">
        Nova vest
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@/shared/eventBus.js'
import { api } from '@/api'
export default {
  name: 'adminNews',
  data () {
    return {
      newsList: [],
      page: 1,
      pageCount: 0,
      search: null
    }
  },
  mounted () {
    this.getNews()
  },
  methods: {
    getNews () {
      let params = {
        page: this.page
      }
      if (this.search && this.search !== '') {
        params.search = this.search
      }
      api.getNews(params).then(res => {
        this.newsList = res.data.data
        this.pageCount = res.data.page_count
      }).catch(e => {
        console.log(e)
      })
    },
    openConfirmModal (news) {
      let modalData = {
        title: 'Jeste li sigurni da želite da obrišete ovu vest',
        ok: () => {
          this.deleteNews(news)
        }
      }
      let params = {
        modalData: modalData,
        component: 'confirmModal'
      }
      eventBus.$emit('openModal', params)
    },
    openNewModal () {
      let modalData = {
        ok: news => {
          this.addNewNews(news)
        }
      }
      let params = {
        modalData: modalData,
        component: 'newNews'
      }
      eventBus.$emit('openModal', params)
    },
    addNewNews (news) {
      api.addNewNews(news).then(res => {
        this.getNews()
        this.$toast.success('Uspešno', {
          duration: 8000
        })
      }).catch(e => {
        console.log(e)
        this.$toast.error('Greška', {
          duration: 8000
        })
      })
    },
    deleteNews (news) {
      api.deleteNews(news.new_id).then(res => {
        this.getNews()
        this.$toast.success('Uspešno', {
          duration: 8000
        })
      }).catch(e => {
        console.log(e)
        this.$toast.error('Greška', {
          duration: 8000
        })
      })
    },
    getPaginationImages (side) {
      let path = require(`@/assets/icons/pagination${side}.png`)
      return `<img src='${path}' alt='pagination left image'>`
    },
    changePage (page) {
      this.page = page
      this.newsList = []
      this.getNews()
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-email-wrapper {
  padding-left: 40px;
  box-sizing: border-box;
  @import '@/assets/scss/btnStyles.scss';
  @import '@/assets/scss/tableStyles.scss';
  table {
    margin-bottom: 20px;
  }

  .title {
    margin-bottom: 25px;
    font-size: 21px;
    color: $text-color;
    text-align: left;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    input {
      border: none;
      border-bottom: 1px solid #ddd;
      -webkit-box-flex: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      height: 20px;
      line-height: 20px;
      padding-right: 20px;
      font-weight: bold;
      font-size: 13px;
      line-height: 15px;
      letter-spacing: 0.02em;
      color: $text-color;
      max-width: 230px;
    }
    input:focus {
      outline: none;
    }
  }
  .editor-wrapper {
    margin-bottom: 20px;
  }
  .action-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    .btn:last-child {
      margin-left: 10px;
    }
  }
}
</style>
